import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 24 24",
  version: "1.1",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "loader_svg__surface1" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M 20.4375 3.5625 L 18.5625 5.4375 C 17.042969 3.921875 15.046875 2.976562 12.910156 2.765625 C 10.773438 2.554688 8.628906 3.089844 6.84375 4.285156 C 5.058594 5.476562 3.742188 7.25 3.121094 9.304688 C 2.496094 11.359375 2.605469 13.566406 3.425781 15.550781 C 4.25 17.535156 5.730469 19.171875 7.625 20.183594 C 9.519531 21.195312 11.703125 21.519531 13.808594 21.101562 C 15.914062 20.683594 17.808594 19.546875 19.171875 17.886719 C 20.535156 16.226562 21.277344 14.148438 21.277344 12 L 23.929688 12 C 23.929688 14.761719 22.972656 17.433594 21.222656 19.570312 C 19.472656 21.703125 17.035156 23.164062 14.328125 23.699219 C 11.621094 24.238281 8.808594 23.824219 6.375 22.523438 C 3.941406 21.21875 2.035156 19.117188 0.976562 16.566406 C -0.078125 14.015625 -0.21875 11.179688 0.582031 8.535156 C 1.382812 5.894531 3.078125 3.613281 5.371094 2.082031 C 7.667969 0.546875 10.421875 -0.144531 13.167969 0.128906 C 15.917969 0.398438 18.484375 1.613281 20.4375 3.5625 Z M 20.4375 3.5625 "
      })
    ], -1)
  ]))]))
}
export default { render: render }